import { useEffect } from "react";
import { displayNotImplemented } from "../../../../../shared/services/Notifications/NotificationServices";

export default function SettingsTab() {
  useEffect(() => {
    displayNotImplemented();
  }, []);
  return <></>;
}
